module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/11mill-active-02528a6eb1c6e8807a8309a470e9d4fb.png";